module.exports = __webpack_public_path__ + "static/img/food-policy022.4788501.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/food-policy022.png
// module id = 6Qr+
// module chunks = 1